module.exports = __webpack_public_path__ + "static/mainLogo-fbe6debde279be4f81f350b36f27229b.png";